(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;

    const queryInput = form.elements.namedItem('q');

    if (!(queryInput instanceof HTMLInputElement)) return;

    const terms = queryInput.value.trim().replaceAll('"', '');

    if (!terms) return;

    queryInput.value = terms
      .split(/\s+/)
      .map((term) => `"${term}"`)
      .join(' ');
  });
  } catch(e) { console.error(e); }
})();

})();
